import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const reviews = [{
  id: 1,
  name: 'Sofía R.',
  service: 'Uñas Acrílicas',
  text: 'El mejor lugar en Xochimilco. Valentina es súper detallista y mis uñas duraron intactas por semanas. ¡El diseño quedó exactamente como lo pedí!',
  rating: 5
}, {
  id: 2,
  name: 'Mariana G.',
  service: 'Balayage y Corte',
  text: 'Llegué con el cabello muy maltratado y me lo dejaron hermoso. La atención es increíble, te hacen sentir como en casa desde que entras.',
  rating: 5
}, {
  id: 3,
  name: 'Elena M.',
  service: 'Masaje Reductivo',
  text: 'Los resultados son reales. Llevo 5 sesiones y he notado muchísima diferencia. El ambiente es súper relajante y profesional.',
  rating: 5
}];
export function Reviews() {
  return <section className="py-20 bg-white" data-id="element-88">
      <div className="container mx-auto px-6" data-id="element-89">
        <div className="text-center mb-16" data-id="element-90">
          <h2 className="text-3xl md:text-4xl font-heading text-mimate-text mb-4" data-id="element-91">
            Lo que dicen nuestras clientas
          </h2>
          <div className="w-16 h-1 bg-mimate-primary mx-auto rounded-full" data-id="element-92"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-93">
          {reviews.map((review, index) => <motion.div key={review.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="bg-mimate-bg p-8 rounded-2xl relative" data-id="element-94">
              <div className="flex text-mimate-primary mb-4" data-id="element-95">
                {[...Array(review.rating)].map((_, i) => <Star key={i} size={18} fill="currentColor" data-id="element-96" />)}
              </div>
              <p className="text-mimate-text/80 italic mb-6 leading-relaxed" data-id="element-97">
                "{review.text}"
              </p>
              <div data-id="element-98">
                <p className="font-bold text-mimate-text" data-id="element-99">{review.name}</p>
                <p className="text-sm text-mimate-primary" data-id="element-100">{review.service}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}